import { Inject, Injectable, NgZone, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import {
  SINGAPORE_SUB_REGION,
  SingaporeSubRegion,
} from './shareModule/services/google-maps.interface';
import { SharedService } from './shareModule/services/shared.service';
import { RoleService } from './shareModule/services/roles/role.service';
import { LocalServiceService } from './shareModule/services/local-service.service';
import { AuthServiceService } from './shareModule/services/auth-service.service';
import { AppState } from './shareModule/states/app.state';
import { CommonService } from './shareModule/services/common.service';
import { Store } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { CustomerService } from './shareModule/services/customer.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

declare const google: any;

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsService implements OnInit, OnDestroy {
  public imgUrl = environment.ImageUrl;

  constructor(
    private customerService: CustomerService,
    private modalService: NgbModal,
    private sharedService: SharedService,
    private ngZone: NgZone,
    private breakpointObserver: BreakpointObserver,

    public roleService: RoleService,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private store: Store<AppState>,
    public commonService: CommonService,
    @Inject('WINDOW') private window: any,
  ) { }

  ngOnDestroy(): void {
    this.servicesSelectedSubRegionSubscription?.unsubscribe();
  }

  private servicesSelectedSubRegion = null;
  private servicesSelectedSubRegionSubscription: Subscription | null = null;

  private prepProductCategoryImages(categoryData) {
    for (const cat of categoryData) {
      this.categoryIconMap.set(cat.id, cat.image);
      for (const subCat of cat.subCategory) {
        this.categoryIconMap.set(subCat.categorieChildId, cat.image);
      }
    }
    //////console.log('done ordering categoryIconMap', this.categoryIconMap)
  }
  private fecthCategoryInfos() {
    this.commonService.categoryList.subscribe((response: any) => {
      if (this.sharedService.isBrowser()) {
        this.prepProductCategoryImages(response);
      }
    });
  }

  private isOnMobile = false;


  ngOnInit(): void {
    this.fecthCategoryInfos();

    this.servicesSelectedSubRegionSubscription =
      this.sharedService.servicesShowingSubRegion.subscribe(
        (subRegion: any) => {
          //////console.log("subscription listened")
          this.servicesSelectedSubRegion = subRegion.subRegionId + '';
        },
      );
  }

  ///////////////////////////////// code related to maps //////////////////////////////////////////////////////////
  // private servicesSelectedSubRegion = null;

  public mapData = [];

  private map: any = null;
  private geocoder: any;
  private lat: number = 1.3521;
  private lng: number = 103.8198;

  private panTo(latLng) {
    this.map.panTo(latLng);
  }

  private async getLatLongByPostalCode(productData) {
    return new Promise((resolve, reject) => {
      let address = productData?.postalCode;
      if (!address) {
        address = productData?.appUser?.postalCode;
      }
      resolve(this.local.getLatLongByPostalCode(address))
    });
  }

  private singaporeSubregions: { [key: number]: SingaporeSubRegion } =
    SINGAPORE_SUB_REGION;

  fitBounds() {
    if (this.markers.length > 0 && this.mapBounds) {
      this.map.fitBounds(this.mapBounds);
    }
  }

  private async addMarkerTo(postalCode) {
    let latLong = await this.local.getLatLongByPostalCode(postalCode)
    if (!latLong) return;

    try {
      latLong = JSON.parse(latLong)
    } catch (e) {
      return;
    }

    this.mapBounds?.extend(latLong);

    this.markers.push(
      new google.maps.Marker({
        position: latLong,
        map: this.map,
      }),
    );


  }

  private mapBounds = this.sharedService.isBrowser()
    ? new google.maps.LatLngBounds()
    : null;

  private mapRetryCount = 1;

  serviceSelectedRegion = null;
  private _checkDevice() {
    if (this.sharedService.isBrowser()) {
      this.breakpointObserver
        .observe([
          Breakpoints.Handset,
          Breakpoints.Small,
          Breakpoints.Medium,
          Breakpoints.Tablet,
        ])
        .subscribe((result) => {
          this.isOnMobile = result.matches;
          // ////console.log('Is mobile:', this.isOnMobile);
        });
    }
  }
  public setZoom(zoom: number) {
    if (this.map) {
      this.map.setZoom(zoom);
    }
  }

  public removeCurrentMap() {
    if (!this.sharedService.isBrowser()) return; //google is found only on the browser
    google.maps.event.clearInstanceListeners(this.map);
    this.map = null; //once a page is dont with the map remove it so it can redraw next time on a new div
  }

  public initMap(products, mapDivId, mapShouldRefresh = true, zoomWhenMarkersAreclicked = true): void {
    //console.trace('initMap', this.mapRetryCount)
    if (!this.sharedService.isBrowser()) {
      //////console.log('map not a browser')
      return; // nothing we can do here cause api needs div
    }

    this._checkDevice();

    this.fecthCategoryInfos();
    this.mapData = products;
    this.mapDivId = mapDivId;

    //////console.log('initMap Got arguments', arguments);
    ////console.log('drawing map')
    this.ngZone.runOutsideAngular(() => {
      this.removeAllMarkers();
      setTimeout(() => {
        try {
          const mapDiv = document.getElementById(mapDivId);
          if (!mapDiv && this.sharedService.isBrowser()) {
            //just making sure again
            console.error('mapDiv not found!');
            if (typeof this.mapRetryCount != 'number' || this.mapRetryCount < 0) {
              console.error("Retry count is no longer a valid number")
              return;
            }
            if (this.mapRetryCount < 4) {
              this.mapRetryCount++;
              setTimeout(
                () => this.initMap(products, mapDivId, mapShouldRefresh),
                1000 * this.mapRetryCount,
              ); //retry again 1 sec latter max 5 times
              return;
            }
          }
          if (mapShouldRefresh || !this.map) {
            if (this.map) {
              google.maps.event.clearInstanceListeners(this.map);
            }

            this.map = new google.maps.Map(mapDiv, {
              gestureHandling: 'greedy',
              center: { lat: this.lat, lng: this.lng },
              styles: [
                {
                  featureType: 'all',
                  elementType: 'labels',
                  stylers: [{ visibility: 'off' }], // Hides all default labels
                },
                {
                  featureType: 'administrative',
                  elementType: 'labels',
                  stylers: [{ visibility: 'on' }], // Show region labels
                },
                {
                  featureType: 'poi',
                  elementType: 'all',
                  stylers: [{ visibility: 'off' }],
                },
              ],
              restriction: {
                latLngBounds: {
                  north: 1.47,
                  south: 1.22,
                  east: 104.05,
                  west: 103.62,
                },
                strictBounds: true,
              },
            });
            this.map.setZoom(14);
          }
          ////console.log('map drawing done')

          this.geocoder = new google.maps.Geocoder();

          const user = this.local.getUser();

          let subRegionId = 59;
          if (user && user.region) {
            subRegionId = user.region;
          }

          //select the region that is selected by the admin
          if (
            this.roleService?.roles?.userType.includes('ADMIN') &&
            this.servicesSelectedSubRegion
          ) {
            subRegionId = this.servicesSelectedSubRegion;
          }
          //////console.log('panning to ', subRegionId)
          this.panTo(this.singaporeSubregions[subRegionId]);
          // const circle = new google.maps.Circle({
          //   center: this.singaporeSubregions[subRegionId],
          //   radius: 2000, // 2 km in meters
          //   map: this.map,
          //   fillColor: "#FF0000",
          //   fillOpacity: 0.3,
          //   strokeColor: "#FF0000",
          //   strokeOpacity: 0.8,
          //   strokeWeight: 2
          // });

          if (user && user.postalCode) {
            this.addMarkerTo(user.postalCode.trim());
          }

          //////console.log('map loaded!');
          this.addProductDataToMap(zoomWhenMarkersAreclicked);
          // setTimeout(()=>{
          //   this.showMap = false;
          // },1000)
        } catch (e) {
          console.error(e);
        }
      });
    });
  }

  public showMap = true;
  public markers = [];
  removeAllMarkers() {
    // ////console.log('removing markers')
    for (const marker of this.markers) {
      marker?.setMap(null);
    }
    this.markers = [];
    //////console.log('markers are', this.markers)
  }

  private getProductInfoHTML(product) {
    return `  <div class='my-card'>
                  <div class='image'>
                  <span class="favorite">
                 
                    <span class="number">${product?.foodFavoritesCount}</span>
                    <i  class="fa-solid fa-heart"> </i>
  
                  </span>
  
                  <div style="position: absolute; top: calc(100% + 0.05em); left: 0" class="d-flex justify-content-between w-100 align-items-center">
                  
                  <div class="product-points">
                    <span class="badge badge-info">XP${product?.points}</span>
                  </div>
                  
                  ${product?.verifiedTag
        ? ` <div class="verified">
                    ${(product?.verifiedTag?.trim()?.length
          ? product?.verifiedTag
          : 'Verified'
        ).toLowerCase()}
                  </div>`
        : ''
      }
                 
                </div>
  
                <div class="product-points" style="position: absolute; bottom: 0; left: 0" *ngIf="list.xpCount">
                  <span class="badge badge-info" style="background-color: var(--primary)"> <i class="fa-solid fa-medal"></i> ${product?.xpCount
      } </span>
                </div>
  
                <img class='img-pro' src='${this.imgUrl + product?.indexImage}' />
                </div>
               
                
                <!-------------------------------------------------------------------------------------->
                <div class="detail">
                  <div class="detail_title">
                    ${product.name} ${product.isDeleted ? ' (DELETED)' : ''}
                  </div>
                  <div class="bar">
                    <div class="w-100 d-flex justify-content-between align-items-center" style="margin-top: 0.1rem">
                      <small class="uniform-small d-inline-block">
                      ${product.unit != 'null' && product.unit != 0
        ? product.unit
        : ''
      }
                      </small>
                      <span class="d-flex align-items-center" style="min-width: fit-content" >
                      <small class="uniform-small mr-1">${product.viewCount
      }</small>
                      <small class="uniform-small">Views</small>
                      </span>
                    </div>
                    <div class="tag">
                      <span class="region" placement="top">
                      ${product?.subRegionName?.split(',').includes('all')
        ? 'Doorstep'
        : this.regionSplit(product?.subRegionName)
      }
                      </span>
                    </div>
                  </div>
                </div>
  
              </div>`;
  }
  private regionSplit(name: string): string {
    return name && name.includes('|') ? name.split('|')[1] : '';
  }
  public get innerWidth() {
    if (this.sharedService.isBrowser()) {
      return this.window.innerWidth;
    }
    return 0;
  }

  private getInfoWindow(product) {
    let midHTML = this.getProductInfoHTML(product);
    const pixelOffset = new google.maps.Size(this.isOnMobile ? 80 : 110, 45);

    //////console.log(this.isOnMobile, pixelOffset)
    return new google.maps.InfoWindow({
      disableAutoPan: true, //no moving with hover,
      pixelOffset,
      content: `
               <div class='popup-products'>
                 ${midHTML}
               </div>
            `,
    });
  }

  private categoryIconMap: Map<string, string> = new Map<string, string>();
  private currentMapZoomLevel = null;
  private currentActiveInfoWindow = null;
  private currentlyShowingInfoWindowOfMarker = null; //this is the referencs to the marker the currentinfowindow is showing. used to check for doub clicks that are used to close the info window
  private markerHTMLElements = [];

  private readonly PROMOTE_URL_MARKER = '#promote';

  private getMarkerForProduct(product, loc, i, zoomWhenMarkersAreclicked) {
    //////console.log("adding product markers to map", arguments)

    let iconUrl = '../../assets/images/shop/default.png';

    if (this.categoryIconMap.has(product.categoryId)) {
      iconUrl = this.imgUrl + this.categoryIconMap.get(product.categoryId);
    } else {
      console.error(
        'error categoryIcon image not found for ' + product.categoryId,
        this.categoryIconMap,
      );
      // ////console.log(iconUrl)
    }
    if (product?.type == 'promote') {
      iconUrl += this.PROMOTE_URL_MARKER;
    }

    //////console.log(iconUrl, 'iconUrl');

    const marker = new google.maps.Marker({
      position: loc,
      map: this.map,
      //optimized: false,
      label: {
        text: `(${i})`,
        color: 'black',
        margin: 16,
        //fontWeight: "bold",
        fontSize: '10px',
      },
      icon: {
        url: iconUrl,
        //mainProduct.indexImage ? this.imgUrl + mainProduct.indexImage : '../../assets/images/shop/default.png',
        scaledSize: new google.maps.Size(42, 42),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(15, 15),
        labelOrigin: new google.maps.Point(20, 50),
      },
    });

    const closeCurrentInfoWindow = () => {
      this.currentActiveInfoWindow?.close();
      this.currentActiveInfoWindow = null;
      this.currentlyShowingInfoWindowOfMarker = null;
    };

    const openMyInfoWindow = (marker) => {
      closeCurrentInfoWindow();

      this.currentActiveInfoWindow = this.getInfoWindow(product); //move it to the right side ofy
      this.currentActiveInfoWindow.open(this.map, marker);
      this.currentlyShowingInfoWindowOfMarker = marker;
    };

    marker.addListener('mouseover', () => {
      openMyInfoWindow(marker);
    });

    marker.addListener('mouseout', () => {
      closeCurrentInfoWindow();
    });

    marker.addListener('click', () => {
      if (this.currentlyShowingInfoWindowOfMarker == marker) {
        closeCurrentInfoWindow();
      } else {
        openMyInfoWindow(marker);
        this.panTo(loc);
        if (zoomWhenMarkersAreclicked) {
          this.map.setZoom(16);
        }

      }
    });

    this.map.addListener('click', () => {
      //close the info window when other parts of the map are clicked
      closeCurrentInfoWindow();
    });

    this.currentMapZoomLevel = this.map.getZoom();

    return marker;
  }
  private addZoomListener() {
    this.map.addListener('zoom_changed', () => {
      const zoomLevel = this.map.getZoom();
      //////console.log({zoomLevel})

      if (zoomLevel == this.currentMapZoomLevel) {
        return;
      }

      this.currentMapZoomLevel = zoomLevel;

      let newSize = 42 + (this.currentMapZoomLevel - 12) * 5;

      //      ////console.log('new size is ', newSize);
      for (const marker of this.markers) {
        const currentIcon = marker.getIcon();
        if (
          typeof currentIcon === 'object' &&
          currentIcon !== null &&
          'url' in currentIcon
        ) {
          marker.setIcon({
            ...currentIcon,
            scaledSize: new google.maps.Size(newSize, newSize),
            // size: new google.maps.Size(newSize, newSize),
          });
          // ////console.log(marker.getIcon());
        }
      }
    });
  }
  private async addProductDataToMap(zoomWhenMarkersAreclicked = true) {
    //////console.log('Adding product data to map');
    const md = this.mapData?.flat();
    if (!md) {
      console.error('No map data found!');
      return;
    }

    for (let i = 0; i < md.length; i++) {
      const product = md[i];
      if (product.type == 'promote' && !product.postalCode) {
        //for shoutouts that don't have postalcode don't place them on the map
        continue;
      }
      try {
        let loc;
        if (product.latLng && product.latLng != '{}') {
          //////console.log('using location for product', product.name)
          loc = JSON.parse(product.latLng);
        } else {
          loc = await this.getLatLongByPostalCode(product);
        }
        if (loc) {
          const marker = this.getMarkerForProduct(product, loc, i + 1, zoomWhenMarkersAreclicked);
          this.mapBounds?.extend(loc);
          if (marker) {
            this.markers.push(marker);
            //this.changeMapMarkerColors()
          }
          // setTimeout(() => this.changeMapMarkerColors(), 1500);
        }
        this.fitBounds();
      } catch (e) {
        console.error(e);
      }
    }
    setTimeout(() => this.changeMapMarkerColors(), 100);
  }

  private mapDivId = 'map';

  private changeMapMarkerColors() {
    const mapImages = document.querySelectorAll(`#${this.mapDivId} img`);
    if (!mapImages) {
      console.error(
        'Could not find map image elements to change color or markers',
      );
      return;
    }
    mapImages.forEach((img: any) => {
      if (
        (!img.src?.includes('kachiing') &&
          !img.src?.includes('localhost:4200')) ||
        img.src?.includes('food')
      )
        return;

      img.classList.add('custom-map-marker');
      if (img.src?.includes(this.PROMOTE_URL_MARKER)) {
        //shoutout as pink
        img.classList.add('custom-map-marker-1');
      } else {
        img.classList.add('custom-map-marker-2'); //the rest as purple
      }
    });
  }
  onImgError(event) {
    event.target.src = '../../assets/images/shop/default.png';
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////
}
